import { LOAD_LANDING_PAGE_SUCCESS } from './ActionTypes'

export const tryLoadLandingPage = () => dispatch => {
  dispatch({
    type: LOAD_LANDING_PAGE_SUCCESS,
    landingPageSettings: widgetInit.landingPageSettings,
  })
}
